import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import { Image } from "@is/components/Image";
import { MediaVariants, TranslationContext } from "@is/constants";
import { BasketItem as BasketItemType } from "@is/types";
import { convertCurrencyCodeToSymbol } from "@is/utils";

import css from "./CheckoutBasketItemTemplate.module.css";

type Props = {
  item: BasketItemType;
  onClick: () => void;
};

const CheckoutBasketItemTemplate = ({ item, onClick }: Props) => {
  const { t } = useTranslation(TranslationContext.Basket);

  return (
    <div className={css.container} onClick={onClick}>
      {!!item.media?.url && (
        <div className={classcat([css.imageContainer])}>
          <Image
            src={item.media?.url}
            mediavariant={MediaVariants.MEDIUM}
            layout="cover"
          />
        </div>
      )}
      <div className={classcat(["text-label-base", css.styleDetailsContainer])}>
        <span className={classcat([css.styleName, css.ellipsis])}>
          {item.productName}
        </span>
        <span className={classcat([css.styleDetailsLabel, css.ellipsis])}>
          {item.colorName}
        </span>
        <span className={css.styleDetailsLabel}>
          {item?.size && item.size}
          {item?.length && item.length && " / "}
          {item?.length && item.length}
        </span>
        {!!(item.price?.retailPrice && item.price?.currencyCode) && (
          <div className={css.price}>
            <strong>
              {`${
                item.price?.salePrice || item.price.retailPrice
              } ${convertCurrencyCodeToSymbol(item.price.currencyCode)}`}
            </strong>
          </div>
        )}
        <div>{`${item.quantity} ${
          item.quantity > 1 ? t("Items") : t("Item")
        }`}</div>
      </div>
    </div>
  );
};

export default CheckoutBasketItemTemplate;
